// extracted by mini-css-extract-plugin
export default {"btn-main":"Button_btn-main__PgUav","btn-alternate":"Button_btn-alternate__-GprU","btn-warn":"Button_btn-warn__NK5Jw","btn-danger":"Button_btn-danger__F116c"};